import firebase from '../../firebase';

export default async function saveStripeCard({ userId, groupId, paymentMethodId }) {
    const card = await firebase.functions().httpsCallable('billing-saveStripeCard')({ userId, groupId, paymentMethodId });
    if (card && card.data) {
        return card.data;
    }
    return undefined;
}
